<template>
    <div class="row personal-data-tab">
        <div class="col-12 col-md-6">
            <subscription-personal-data-management
                :subscription-data="subscriptionData"
            ></subscription-personal-data-management>
        </div>

        <div v-if="this.$root.whitelabel.isUs()" class="col-12 col-md-6">
            <subscription-ssn-management
                :subscription-data="subscriptionData"
            ></subscription-ssn-management>
        </div>
    </div>
</template>

<script>
import SubscriptionPersonalDataManagement from "../molecules/SubscriptionPersonalDataManagement.vue";
import SubscriptionSsnManagement from "../molecules/SubscriptionSsnManagement.vue";

export default {
    name: 'CdbTabPersonalData',
    components: {
        SubscriptionPersonalDataManagement,
        SubscriptionSsnManagement
    },

    props: {
        subscriptionData: null
    },
    computed: {

    }
}
</script>
